import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { authAction } from "../redux/auth-slice";
import useHttps from "./useHttps";
import useReporting from "./useReporting";

const useAuth = () => {
   const { sendRequest } = useHttps();
   const { reportingService, apiErrorReportingService } = useReporting();
   const dispatch = useDispatch();
   const navigate = useNavigate();

   const loginSuccess = (data) => {
      reportingService("User logged in successfully", "success");
      dispatch(authAction.setTokenData(data));
      dispatch(authAction.setLoginStatus(true));
      navigate("/user/dashboard");
   };

   const loadingFunc = (value) => {
      dispatch(authAction.setLoading(value));
   };

   const logoutUser = () => {
      dispatch(authAction.setTokenData({}));
      navigate("/login");
   };

   const loginUser = ({ username, password, grant_type }) => {
      const params = new URLSearchParams();
      params.append("username", username);
      params.append("password", password);
      params.append("grant_type", grant_type);

      const config = {
         method: "post",
         data: params,
         url: `oauth/token`,
         headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Authorization: "Basic dXJiY3NydmlkOnNlY3JldEAxMjM=",
         },
      };
      sendRequest(config, loginSuccess, loadingFunc, apiErrorReportingService);
   };

   return { loginUser, logoutUser };
};

export default useAuth;
